import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CompanyCycleRequest, CompanyCycleResponse, PageResponseV2 } from '../models/empresa.model';

@Injectable({ providedIn: 'root' })
export class CompanyCycleApiService {
  private readonly apiUrl = `${environment.apiUrl}api/company-cycles`;

  constructor(private http: HttpClient) {}

  getAll(businessId: number, params?: { page?: number; size?: number }): Observable<PageResponseV2<CompanyCycleResponse>> {
    let qp = new HttpParams().set('businessId', businessId);
    if (params?.page != null) qp = qp.set('page', params.page);
    if (params?.size != null) qp = qp.set('size', params.size);
    return this.http.get<PageResponseV2<CompanyCycleResponse>>(this.apiUrl, { params: qp });
  }

  getById(id: number, businessId: number): Observable<CompanyCycleResponse> {
    return this.http.get<CompanyCycleResponse>(`${this.apiUrl}/${id}`, {
      params: new HttpParams().set('businessId', businessId)
    });
  }

  create(cycle: CompanyCycleRequest): Observable<CompanyCycleResponse> {
    return this.http.post<CompanyCycleResponse>(this.apiUrl, cycle);
  }

  update(id: number, cycle: CompanyCycleRequest): Observable<CompanyCycleResponse> {
    return this.http.put<CompanyCycleResponse>(`${this.apiUrl}/${id}`, cycle);
  }

  delete(id: number, businessId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, {
      params: new HttpParams().set('businessId', businessId)
    });
  }

  // POST /api/company-cycles/reorder?businessId= — body: ids en el nuevo orden (lista COMPLETA).
  // El backend asigna display_order por posición empezando en 1. Responde 204 sin body.
  reorder(businessId: number, orderedIds: number[]): Observable<void> {
    const params = new HttpParams().set('businessId', businessId);
    return this.http.post<void>(`${this.apiUrl}/reorder`, orderedIds, { params });
  }
}
